import "intersection-observer";

const state = {
  isReviewsAnimated: false,
  isAboutAnimated: false,
  isContactFormAnimated: false,
};

// Sections we are tracking
const reviewsContainer = document.querySelector(
  "#reviews > div.reviews-container"
);
const aboutContainer = document.querySelector("#about");
const contactFormContainer = document.querySelector("#contact-form");

// Animation handlers
const initReviewsAnimation = () => {
  const state = {
    maxIteration: 3,
    currentIteration: 0,
  };

  // Events
  const listeners = {
    reviewsAnimation: null,
    toggleNext: null,
    togglePrevious: null,
  };

  const currentStepNumber = reviewsContainer.querySelector(".current");
  const nextButton = reviewsContainer.querySelector("button.next");
  const previousButton = reviewsContainer.querySelector("button.previous");

  reviewsContainer.classList.add("show");

  const toggleScaler = (on) => {
    if (on) {
      reviewsContainer.classList.add(`scaling`);
    } else {
      reviewsContainer.classList.remove(`scaling`);
    }
  };

  const toggleFactory = (direction) => () => {
    clearInterval(listeners.reviewsAnimation);
    listeners.reviewsAnimation = setInterval(() => {
      toggleFactory(1)();
    }, 4300);

    // Remove previous class
    reviewsContainer.classList.remove(`animated-${state.currentIteration}`);

    if (direction > 0) {
      state.currentIteration =
        state.currentIteration + 1 > state.maxIteration
          ? 1
          : state.currentIteration + 1;
    } else {
      state.currentIteration =
        state.currentIteration - 1 === 0
          ? state.maxIteration
          : state.currentIteration - 1;
    }

    reviewsContainer.classList.add(`animated-${state.currentIteration}`);
    currentStepNumber.innerText = `0${state.currentIteration}`;

    toggleScaler(false);

    setTimeout(() => {
      toggleScaler(true);
    }, 5000);
  };

  listeners.toggleNext = toggleFactory(1);
  listeners.togglePrevious = toggleFactory(-1);

  // Setup button listeners
  nextButton.addEventListener("click", listeners.toggleNext);
  previousButton.addEventListener("click", listeners.togglePrevious);

  listeners.toggleNext();
};

// Init
const setupScrollListener = () => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute("id");

        if (entry.isIntersecting) {
          switch (id) {
            case "reviews-container":
              if (!state.isReviewsAnimated) {
                state.isReviewsAnimated = true;
                initReviewsAnimation();
              }
              break;
            case "about":
              if (!state.isAboutAnimated) {
                state.isAboutAnimated = true;
                aboutContainer.classList.add("show");
              }
              break;
            case "contact-form":
              if (!state.isContactFormAnimated) {
                state.isContactFormAnimated = true;
                contactFormContainer.classList.add("show");
              }
            default:
              return;
          }
        }

        // Check if all elements are animated – disconnect IntersectionObserver if they are.
        const allElementsAnimated =
          Object.entries(state).filter((entry) => entry[1] === false).length ===
          0;

        if (allElementsAnimated) {
          observer.disconnect();
        }
      });
    },
    {
      threshold: [0.5],
    }
  );

  const sections = [reviewsContainer, aboutContainer, contactFormContainer];
  sections.forEach((section) => observer.observe(section));
};

setupScrollListener();
